enum FirebaseCollections {
  PROCESS_REQUEST = 'sync-message',
}

const getProcessRequestSubscription = (): string =>
  `${FirebaseCollections.PROCESS_REQUEST}-${process.env.VITE_APP_ENV_COLLECTION}`;

export { getProcessRequestSubscription };
